import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '../ButtonNew';

const OpeningTimesButtons = ({
  isEditing,
  isSaveDisabled,
  onEditClick,
  onSaveClick,
  onCancelClick,
}) => {
  if (isEditing) {
    return (
      <div className="DealerOpeningTimes__buttons-group">
        <Button
          className="DealerOpeningTimes__buttons-cancel"
          variant="secondary"
          onClick={onCancelClick}
        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button variant="primary" onClick={onSaveClick} isDisabled={isSaveDisabled}>
          <FormattedMessage id="save" />
        </Button>
      </div>
    );
  }

  return (
    <div className="DealerOpeningTimes__buttons-group">
      <Button variant="primary" onClick={onEditClick}>
        <FormattedMessage id="edit" />
      </Button>
    </div>
  );
};

OpeningTimesButtons.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isSaveDisabled: PropTypes.bool.isRequired,
};

export default OpeningTimesButtons;



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/OpeningTimesButtons.jsx